import gsap from 'gsap'

document.addEventListener('DOMContentLoaded', () => {
	return 
    const foodMenu = document.querySelector('.menus__food')
    const drinksMenu = document.querySelector('.menus__drinks')
    const foodButton = document.querySelector('.menus__button--food')
    const drinksButton = document.querySelector('.menus__button--drinks')

    drinksButton.addEventListener('mouseenter', () => {
			gsap.to(foodMenu, {
				transform: 'rotate(-5deg) translateX(0)',
				zIndex: 1,
			})
			gsap.to(drinksMenu, {
				transform: 'rotate(5deg) translateX(0)',
				zIndex: 2,
			})
    });
    foodButton.addEventListener('mouseenter', () => {
			gsap.to(drinksMenu, {
				transform: 'rotate(-5deg) translateX(0)',
				zIndex: 1,
			})
			gsap.to(foodMenu, {
				transform: 'rotate(5deg) translateX(0)',
				zIndex: 2,
			})
    });
});

export default () => {}